import PromineoTabs from "components/common/controls/PromineoTabs";
import PanelHeader from "fetaures/docs/HowItWorks/PanelHeader";
import PromineoSimpleDataGrid from "components/common/controls/grid/PromineoSimpleDataGrid";
import "./styles/ExampleDataViewerGrid.css";
import RequestJsonViewer from "./RequestJsonViewer";
import SectionLabel from "./SectionLabel";
import { ScrollView } from "devextreme-react";
import { Scrolling } from "devextreme-react/data-grid";
import React from "react";

const fieldKeyDisplayNameMap: Record<string, string> = {
  StartDateField: "Start date",
  FinishDateField: "Finish date",
  ProfileKeyField: "Profile key",
  CalendarKeyField: "Calendar key",
  ActivityKeyField: "Activity key",
  ValueField: "Value",
};

interface Props {
  data: object;
}

const ExampleDataViewer = React.memo((props: Props) => {
  const getData: any = () => {
    return props.data || {};
  };

  const getActivities = () => {
    const json = getData();
    return json.Activities || [];
  };

  const getFieldMappings = () => {
    const json = getData();
    let mapping = json.FieldMappings || {};
    return { ...mapping, Value: mapping["ValueField"].Field };
  };

  const Header = () => {
    return <PanelHeader stepCount={2} title="Label your input data" />;
  };

  const customizeColumns = (columns: any) => {
    const fieldMappings = getFieldMappings();

    columns.forEach((column: any) => {
      let caption = "-";
      const existingMap = Object.entries(fieldMappings).find(
        (keyValue: any) => keyValue[1] === column.dataField
      );
      if (existingMap) {
        caption = fieldKeyDisplayNameMap[existingMap[0]] || existingMap[0];
      }

      column.columns = [
        {
          caption: caption,
          dataField: column.dataField,
          allowSorting: false,
          format: column.format
        },
      ];
    });
  };

  const TableComponent = () => {
    return (
      <div>
        <SectionLabel label="Table" />
        <ScrollView>
          <div className="max-h-150">
            <PromineoSimpleDataGrid
              classNames="example-data-viewer-grid"
              dataGridOptions={{
                sorting: { mode: "none" },
                dataSource: getActivities(),
                customizeColumns: customizeColumns,
                noDataText: "No Data",
                style: { maxHeight: "37.5rem" },
              }}
            >
              <Scrolling mode="virtual" rowRenderingMode="virtual" />
            </PromineoSimpleDataGrid>
          </div>
        </ScrollView>
      </div>
    );
  };

  const JsonView = () => {
    return <RequestJsonViewer json={getData()} />;
  };

  return (
    <>
      <PromineoTabs
        tabs={[
          {
            component: TableComponent,
            title: "Table",
          },
          {
            component: JsonView,
            title: "JSON",
          },
        ]}
        tabsLabel="Viewing mode"
        header={Header}
      />
    </>
  );
});

export default ExampleDataViewer;
